import Head from 'next/head';
import { useRouter } from 'next/router';

const Canonical = () => {
  const router = useRouter();
  const path = router.asPath.split('?')[0];
  const canonical = `https://www.yesware.com${router.basePath}${path}`;

  return (
    <Head>
      <link rel="canonical" href={canonical} />
      <meta property="og:url" content={canonical} />
    </Head>
  );
};

export default Canonical;
